import Marquee from "react-fast-marquee";

const WORDS = [
  "Trading Cards",
  "Vintage Finds",
  "Hand-Crocheted",
  "100% Cotton",
  "Graded Collectibles",
  "Editorial Curation",
  "Poshmark",
  "eBay",
  "Facebook Marketplace",
  "Hamilton, Ontario",
];

export default function MarqueeStrip() {
  return (
    <section
      className="relative border-y border-[#262626] bg-[#050505] py-7 md:py-9 overflow-hidden"
      data-testid="marquee-strip"
      aria-hidden="true"
    >
      <Marquee
        speed={38}
        gradient={false}
        pauseOnHover={false}
        className="font-display text-[8vw] md:text-[5.5vw] leading-none tracking-[-0.03em] text-[#f5f5f5] font-medium"
      >
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 md:mx-14 inline-flex items-center gap-8 md:gap-14">
            {w}
            <span className="text-[#c48a64]">◆</span>
          </span>
        ))}
        {WORDS.map((w, i) => (
          <span key={`b-${i}`} className="mx-8 md:mx-14 inline-flex items-center gap-8 md:gap-14">
            {w}
            <span className="text-[#c48a64]">◆</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
